import { TempLineModel } from "./temp-line.model";

export class TempUnitModel {
    unitId: string;
    workingHours: string;
    dates: string; // in the CSV format of YYYY-MM-DD ex: "2024-03-02,2024-03-03,2024-03-04"
    lines: TempLineModel[];

    constructor(
        unitId: string,
        workingHours: string,
        dates: string,
        lines: TempLineModel[]
    ) {
        this.unitId = unitId;
        this.workingHours = workingHours;
        this.dates = dates;
        this.lines = lines;
    }
}